import { render, staticRenderFns } from "./OptionWidget.vue?vue&type=template&id=83620414&"
import script from "./OptionWidget.vue?vue&type=script&lang=js&"
export * from "./OptionWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports